import { z } from 'zod';
import { textSchema } from './IText';
export const termsSchema = z.object({
  general_terms_modal_title: z.string().nullable().default(''),
  general_terms_version: z.string().nullable().default(''),
  general_terms_modal_button_text: z.string().nullable().default(''),
  general_terms: z.array(textSchema).nullable().default([]),
  general_terms_intro_paragraph: z.array(textSchema).nullable().default([]),

  data_retention_modal_title: z.string().nullable().default(''),
  data_retention_version: z.string().nullable().default(''),
  data_retention_modal_button_text: z.string().nullable().default(''),
  data_retention_terms: z.array(textSchema).nullable().default([]),
  data_retention_intro_paragraph: z.array(textSchema).nullable().default([]),

  customer_club_modal_title: z.string().nullable().default(''),
  customer_club_version: z.string().nullable().default(''),
  customer_club_modal_button_text: z.string().nullable().default(''),
  customer_club_terms: z.array(textSchema).nullable().default([]),
  customer_club_intro_paragraph: z.array(textSchema).nullable().default([]),
});
export const termsResponseSchema = z.object({
  data: z.object({
    SiteProperties: termsSchema,
  }),
});

export type ITerms = z.infer<typeof termsSchema>;
export type ITermsResponse = z.infer<typeof termsResponseSchema>;
